import { CountryInformationService } from './../../../@core/mock/country-information.service';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { takeWhile } from 'rxjs/operators';
import { CountryInformationSummary } from '../../../@core/data/country-information';
import { Router } from '@angular/router';
import { CountryService } from '../../../@core/mock/country.service';

@Component({
  selector: 'ngx-stepper',
  templateUrl: 'stepper.component.html',
  styleUrls: ['stepper.component.scss'],
})
export class StepperComponent implements OnDestroy , OnInit {

  private alive = true;

  stepList : CountryInformationSummary[];
  
  debutLien = 'assets/country-informations/';
  finLien = '-information.json';
  lienInfo: string;
  countryName: string = '';
  countryType: string = '';

  constructor(private route: Router,
    private countryInformationService: CountryInformationService,
    private countryService: CountryService) {
      
      this.countryName = this.route.getCurrentNavigation().extras.state.countryName;
      if (this.route.getCurrentNavigation().extras.state.countryType === ''){
        this.countryType = this.countryService.changeNameToType(this.countryName);
      } else this.countryType = this.route.getCurrentNavigation().extras.state.countryType;
      this.lienInfo = this.debutLien + this.countryType + this.finLien;
      this.countryInformationService.getInformationJson(this.lienInfo)
      .pipe(takeWhile(() => this.alive))
      .subscribe((jsonInfo) => {
        this.stepList = jsonInfo.stepInformations;
        console.log("stepList", this.stepList);
      });
      console.log(" stepper information", this.countryType, ' / ', this.countryName, ' / ', this.lienInfo);
  }
  ngOnInit() {
  }
  ngOnDestroy() {
    this.alive = false;
  }
}
